export default "__VITE_ASSET__Ck9nqEt3__"